module.exports = __webpack_public_path__ + "static/patient_serie_07-1998.8929a859.gif";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project2/patient_serie_07-1998.gif
// module id = 498
// module chunks = 8418805283199